// Все английские enum-значения, приходящие с бэка, в русские лейблы.

export const ORDER_STATUS: Record<string, string> = {
  pending: 'Ожидает',
  delivered: 'Выдано',
  failed: 'Ошибка',
  refunded: 'Возврат',
};

export const TX_STATUS: Record<string, string> = {
  pending: 'Ожидает',
  paid: 'Оплачено',
  failed: 'Ошибка',
  cancelled: 'Отменено',
};

export const DELIVERY_STATUS: Record<string, string> = {
  queued: 'В очереди',
  sent_rcon: 'Отправлено в RCON',
  pending_plugin: 'Ждёт плагин',
  done: 'Готово',
  failed: 'Ошибка',
};

export const PROVIDER: Record<string, string> = {
  yookassa: 'ЮKassa',
  yoomoney: 'YooMoney',
  cryptobot: 'CryptoBot',
  manual: 'Ручное',
};

export const PRODUCT_KIND: Record<string, string> = {
  pass: 'Проходка',
  role: 'Роль',
  item: 'Предмет',
  bundle: 'Набор',
  custom: 'Прочее',
};

export const USER_ROLE: Record<string, string> = {
  user: 'Игрок',
  admin: 'Админ',
};

export function ruLabel(map: Record<string, string>, key: string | null | undefined): string {
  if (!key) return '-';
  return map[key] ?? key;
}
